<template>
  <div class="layout-category-header">
    <div class="s-16 w-600 uppercase prefix"><slot name="prefix"></slot></div>
    <div class="title font-palantino"><slot name="title"></slot></div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.layout-category-header {
  text-align: left;
  padding: 2em var(--big-gap);
}
.title {
  font-size: 3.43em;
}
.subtitle {
  margin-top: 1em;
}
.prefix {
  margin-bottom: 1em;
  & > * {
    a {
      font-size: 14px;
      text-transform: none;
      &:not(:last-child) {
        text-decoration: underline;
        &:after {
          content: '';
          display: inline-block;
          position: relative;
          top: -2px;
          width: 6px;
          height: 6px;
          background: url('../../../assets/icons/small-arrow.svg');
          background-size: contain;
          background-position: center;
          margin: 0 0.7em;
          background-repeat: no-repeat;
        }
      }
    }
    span {
      font-size: 14px;
      text-transform: none;
      opacity: 0.4;
    }
  }
}

@media screen and (max-width: 1380px) {
  .layout-category-header {
  }
}

@media screen and (max-width: 767px) {
  .layout-category-header {
    padding-block: 10px;
  }
  .title {
    font-size: 40px;
  }
}
</style>